import { Accessor, createContext, JSX, useContext } from "solid-js";
import { BrandL2WebstoreTelescopeRouteData } from "../data/brandl2_webstore_telescope_route_data";
import { useBrandl2WebstoreTelescope } from "../hooks/useBrandl2WebstoreTelescope";

export type BrandL2WebstoreTelescopeContextValue = {
  routeData: Accessor<BrandL2WebstoreTelescopeRouteData>;
  onBrandClick: (brandKey: string) => void;
} & ReturnType<typeof useBrandl2WebstoreTelescope>;

const BrandL2WebstoreTelescopeContext =
  createContext<BrandL2WebstoreTelescopeContextValue>();

export function useBrandl2WebstoreTelescopeContext() {
  const context = useContext(BrandL2WebstoreTelescopeContext);
  if (!context) {
    throw new Error(
      "useBrandl2WebstoreTelescopeContext must be used within BrandL2WebstoreTelescopeProvider"
    );
  }
  return context;
}

export function BrandL2WebstoreTelescopeProvider(props: {
  children: JSX.Element;
  value: BrandL2WebstoreTelescopeContextValue;
}) {
  return (
    <BrandL2WebstoreTelescopeContext.Provider value={props.value}>
      {props.children}
    </BrandL2WebstoreTelescopeContext.Provider>
  );
}
